module.exports = __webpack_public_path__ + "static/media/hot73.97703001.jpg";